import { isNumber } from 'radash';

import { Checkbox } from '@/components/core/Checkbox';
import { useCRUDView } from '@/hooks/useCRUDView';
import { DataModelAttribute } from '@/types/DataModel';

const EditorView = ({attribute}:{attribute: DataModelAttribute}) => {

    const {setView, onEditView, getAllViews} = useCRUDView();
    const isEditViewValid = isNumber(onEditView);
    const viewToEdit = isEditViewValid ? getAllViews()[onEditView] : undefined;

    const onHandleClick = (pressed: boolean) =>{
        setView(prevState => {
            if (!pressed) {
                if (!prevState.fields.includes(attribute.name)) {
                    prevState.fields?.push(attribute.name);
                }
            } else {
                const fields = prevState.fields?.filter(attributeName => attributeName !== attribute.name);
                prevState.fields = fields;
            }
            return prevState;
        });
    };

    const defaultPressed = viewToEdit?.fields?.includes(attribute.name) ? false : true;

    return (<div>
        <Checkbox id="select-view" isChecked={defaultPressed} onCheckedChange={(pressed: any) => onHandleClick(pressed)}/>
    </div>);
};

export {EditorView};
